import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import Icon from "semantic-ui-react/dist/es/elements/Icon";

const GettingStartedOverview = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                getting_started_overview: 1,
            },
        };
        dispatch(configure_getting_started_progress(obj));
    }, []);

    // const configureProgress = () => {
    //     let obj = {
    //         // total_sections: 33,
    //         progress_config: {
    //             getting_started_overview: 1,
    //         },
    //     };
    //     dispatch(configure_getting_started_progress(obj));
    // };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        <Icon name="home" size="large" className="icon_content" color="#268af6" width="20px" height="20px" />
                        <span className="content_title">Overview</span>
                    </div>
                    <div className="text_content">
                        {/* <p>{`Welcome to homepage of Radarr , You can access various modules from here, Please use the Module selector to toggle between different Modules`}</p> */}
                        <p>{`Welcome to Radarr!  You can access various modules from here.`}</p>
                        <p>There are four modules in the platform.</p>
                        <p>1. Listening - Track social media conversations in real time</p>
                        <p>2. Response - Engage with your customers and resolve their queries quickly.</p>
                        <p>3. Publishing - Create, schedule and publish content to various social media channels from within our platform.</p>
                        <p>4. Page Analytics - Analyze the data from your own social media pages in real time.</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/UyWPC5ampI4"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default GettingStartedOverview;
